function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-blockquote\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.56,23a14.35,14.35,0,0,1,6.51-12.45,1.76,1.76,0,0,1,2.51.55h0a1.75,1.75,0,0,1-.45,2.29c-2.9,2.22-4.41,4.68-4.46,8.41a2.31,2.31,0,0,0,0,.37l.17.94a1,1,0,0,1-1.81.83h0a1,1,0,0,1,.25-1.53,3.54,3.54,0,0,1,2-.57,3.79,3.79,0,0,1,4,3.82,3.87,3.87,0,0,1-4,4.19C10.33,29.81,8.56,27.35,8.56,23Zm13.38,0a14.38,14.38,0,0,1,6.51-12.45,1.76,1.76,0,0,1,2.51.55h0a1.74,1.74,0,0,1-.45,2.29c-2.9,2.22-4.41,4.68-4.45,8.41a1.54,1.54,0,0,0,0,.37l.16.94a1,1,0,0,1-1.81.83h0a1,1,0,0,1,.26-1.53,3.5,3.5,0,0,1,2-.57,3.78,3.78,0,0,1,4,3.82,3.86,3.86,0,0,1-4,4.19C23.71,29.81,21.94,27.35,21.94,23Z",
  fill: "#231f20"
});

function SvgCmsBlockquote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgCmsBlockquote;